import getOperationType from './getOperationType';

export default getOperationType;
